import { withSuspense } from '@lib/common/hoc';
import { lazy } from 'react';

const EditC2CViewMappingPage = withSuspense(lazy(() => import('./edit-c2c-deal')));
export default EditC2CViewMappingPage;
